export default "https://cdn.questicon.mathletics.com/assets/images/CloudBumpy-7a5b0530cd073ed313e57f62d29f87d4.png";